<div fxLayout="column">
  <mat-form-field class="full-width">
    <mat-label>{{ 'call_transfer.transfer_reason' | translate }}</mat-label>
    <textarea matInput [(ngModel)]="transferData.transfer_reason"
      placeholder="{{ 'call_transfer.transfer_reason' | translate }}"></textarea>
  </mat-form-field>
</div>
